'use es6';

import { useCallback, useReducer } from 'react';
import taskDeleteReducer, { initialState } from 'collaboration-sidebar/reducers/taskDelete';
import { MSG_TYPE_CONFIRM_DELETE_TASK, MSG_TYPE_DELETE_TASK, MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL, MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useTaskDeleteModal(sendMessage) {
  const [state, dispatch] = useReducer(taskDeleteReducer, initialState);
  const {
    show,
    taskId
  } = state;
  const handleMessage = useCallback(({
    payload
  }) => dispatch(payload), []);
  const onClose = useCallback(() => {
    if (show) {
      dispatch({
        type: MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL
      });
    }
  }, [show]);
  const onDelete = useCallback(() => {
    if (show) {
      sendMessage(MSG_TYPE_DELETE_TASK, {
        taskId
      });
      dispatch({
        type: MSG_TYPE_CONFIRM_DELETE_TASK
      });
    } else {
      dispatch({
        type: MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL
      });
    }
  }, [sendMessage, show, taskId]);
  return Object.assign({}, state, {
    handleMessage,
    onClose,
    onDelete
  });
}